var objRetourInvalide = {"statusCode": 400, "dataApi": [] }

export async function apiTypeCertifAppelBase(utilisateurBearer, suiteUrl) {
    if (utilisateurBearer == ""  || suiteUrl == "") return objRetourInvalide;

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiBase.url  + "/types-certif/" + suiteUrl;
    if(global.config.modeDebugApi == 1) console.log(`appel ${urlApi}`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200 && response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "Il y a plus de XXX résultats ({XXXX), veuillez affiner votre recherche"

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiCertifAppelBase', error_1);
        return objRetour;
    }
}

export async function  apiAppellationTypeDiplomeAjout(utilisateurBearer, datasToPost, idTypeCertif) {
    if (utilisateurBearer == "" || idTypeCertif == "") return objRetourInvalide;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(datasToPost)
    };

    var urlApi = global.config.apiBase.url  + "/types-certif/" + idTypeCertif + "/autresAppellation/";
    if(global.config.modeDebugApi == 1) console.log(`appel POST ${urlApi} dans apiAppellationTypeDiplomeAjout`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200 && response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiAppellationTypeDiplomeAjout', error_1);
        return objRetour;
    }
}
export async function apiAppellationTypeDiplomeModif(utilisateurBearer, datasToPost, idDetail) {
    if (utilisateurBearer == "" || idDetail == "") return objRetourInvalide;

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(datasToPost)
    };

    var urlApi = global.config.apiBase.url  + "/types-certif/autresAppellation/" +  idDetail;
    if(global.config.modeDebugApi == 1) console.log(`appel PUT ${urlApi} dans apiAppellationTypeDiplomeModif`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiAppellationTypeDiplomeModif', error_1);
        return objRetour;
    }
}


export async function apiAppellationTypeDiplomeSuppr(utilisateurBearer, idTypeCertif, idDetail) {
    if (utilisateurBearer == "" || idTypeCertif == ""|| idDetail == "") return objRetourInvalide;
    var objRetour = {statusCode : '', dataApi : ''};

    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiBase.url  + "/types-certif/autresAppellation/" +  idDetail;
    if(global.config.modeDebugApi == 1) console.log('appel ' + urlApi);

    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized, 204 NoContent si succès de la suppresion
        return objRetour;
    } catch (error_1) {
        console.log('error apiAppellationTypeDiplomeSuppr', error_1);
        return objRetour;
    }
}


export async function apiAppellationTypeDiplomeGet(utilisateurBearer, idTypeCertif, idDetail) {
    if (utilisateurBearer == "" || idTypeCertif == ""|| idDetail == "") return objRetourInvalide;
    var objRetour = {statusCode : '', dataApi : ''};

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiBase.url  + "/types-certif/autresAppellation/" +  idDetail;
    if(global.config.modeDebugApi == 1) console.log('appel ' + urlApi);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200) return objRetour;

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiRecrutementSGet', error_1);
        return objRetour;
    }
}